import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchAdminReports = createAsyncThunk(
  "reports/fetchAdmin",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await api.get("/reports/all/list", { params });
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to load reports"
      );
    }
  }
);

export const deleteAdminReport = createAsyncThunk(
  "reports/deleteAdmin",
  async (reportId, { rejectWithValue }) => {
    try {
      await api.delete(`/reports/${reportId}`);
      return reportId;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete report"
      );
    }
  }
);

export const downloadAdminReport = createAsyncThunk(
  "reports/downloadAdmin",
  async ({ id, title }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/reports/${id}/download`, {
        responseType: "blob",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${(title || "report").replace(/[^\w.-]+/g, "_")}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to download report"
      );
    }
  }
);

const reportSlice = createSlice({
  name: "reports",
  initialState: {
    reports: [],
    pagination: { total: 0, page: 1, limit: 20, totalPages: 0 },
    loading: false,
    error: null,
    downloadId: null,
  },
  reducers: {
    clearReportError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload.reports || [];
        const p = action.payload.pagination || {};
        state.pagination = {
          total: p.total ?? 0,
          page: p.page ?? 1,
          limit: p.limit ?? 20,
          totalPages: p.totalPages ?? 0,
        };
      })
      .addCase(fetchAdminReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAdminReport.fulfilled, (state, action) => {
        state.reports = state.reports.filter((r) => r.id !== action.payload);
        state.pagination.total = Math.max(0, state.pagination.total - 1);
      })
      .addCase(downloadAdminReport.pending, (state, action) => {
        state.downloadId = action.meta.arg.id;
      })
      .addCase(downloadAdminReport.fulfilled, (state) => {
        state.downloadId = null;
      })
      .addCase(downloadAdminReport.rejected, (state) => {
        state.downloadId = null;
      });
  },
});

export const { clearReportError } = reportSlice.actions;
export default reportSlice.reducer;
